var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.87886 14.8076L4.92578 10.8545L14.5884 1.19141L18.5415 5.14448L8.87886 14.8076ZM7.18398 10.8545L8.87886 12.5494L16.2837 5.14448L14.5889 3.44961L7.18398 10.8545Z",
    fill: "#374957"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4097 5.27089L17.2808 4.14156C17.7481 3.67421 17.7481 2.91404 17.2808 2.44669C16.8134 1.97933 16.0533 1.97978 15.5859 2.44669L14.457 1.31736C15.5471 0.227322 17.3201 0.227769 18.4101 1.31736C19.4997 2.40741 19.4997 4.18084 18.4097 5.27089Z",
    fill: "#374957"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.28277 15.5532C4.99307 15.5532 4.71186 15.4389 4.50296 15.23C4.2454 14.9724 4.13157 14.6046 4.19853 14.2466L4.66052 11.7795C4.66633 11.7487 4.66945 11.7255 4.67034 11.7099C4.6949 11.2975 4.86898 10.9105 5.16046 10.619L6.05722 9.72266L10.0103 13.6757L9.11354 14.5725C8.83634 14.8497 8.46942 15.022 8.07929 15.0581C7.99225 15.0662 7.89806 15.0827 7.82575 15.0961L5.48631 15.534C5.41847 15.5469 5.35017 15.5532 5.28277 15.5532ZM6.21747 12.1411L5.90099 13.8324L7.53204 13.5271C7.55123 13.5235 7.57132 13.5199 7.5923 13.5159L6.21747 12.1411Z",
    fill: "#374957"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3388 18.4995H3.90965C2.1804 18.4995 0.773438 17.0925 0.773438 15.3632V5.93407C0.773438 4.20482 2.1804 2.79785 3.90965 2.79785H9.67634V4.10438H3.90965C2.90085 4.10438 2.07997 4.92526 2.07997 5.93407V15.3632C2.07997 16.372 2.90085 17.1929 3.90965 17.1929H13.3388C14.3476 17.1929 15.1685 16.372 15.1685 15.3632V9.98445H16.475V15.3632C16.475 17.0925 15.0681 18.4995 13.3388 18.4995Z",
    fill: "#374957"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/editOutline.5ab9178206ee77f46f69ee576b979674.svg";
export { ForwardRef as ReactComponent };